import * as SmartySDK from 'smartystreets-javascript-sdk';

import {
  getAddressClientId,
  isAddressProxyEnabled,
  resolveZipViaProxy,
} from '../../../services/addressApi';
import { SMARTY_EMBEDDED_KEY } from './labConstants';
import { parseRateLimitError } from '../../../utils/rateLimit';

let zipcodeClient;

function getZipcodeClient() {
  if (!SMARTY_EMBEDDED_KEY) return null;
  if (!zipcodeClient) {
    const credentials = new SmartySDK.core.SharedCredentials(SMARTY_EMBEDDED_KEY);
    zipcodeClient = new SmartySDK.core.ClientBuilder(credentials).buildUsZipcodeClient();
  }
  return zipcodeClient;
}

export async function resolveStateFromZip(zipCode) {
  const zip = String(zipCode || '').trim();
  if (!/^\d{5}$/.test(zip)) {
    throw new Error('Enter a valid 5-digit ZIP code.');
  }
  const proxyClientId = getAddressClientId();
  if (isAddressProxyEnabled() && proxyClientId) {
    try {
      const result = await resolveZipViaProxy(proxyClientId, zip);
      return { state: result.state, city: result.city || '' };
    } catch (error) {
      const rateLimitMsg = parseRateLimitError(error);
      if (rateLimitMsg) {
        const rateLimitErr = new Error(rateLimitMsg);
        rateLimitErr.isRateLimit = true;
        rateLimitErr.status = 429;
        throw rateLimitErr;
      }
      console.warn('Address proxy ZIP lookup failed, trying embedded Smarty:', error);
    }
  }

  const client = getZipcodeClient();
  if (!client) {
    throw new Error('ZIP verification is temporarily unavailable. Select your state to continue.');
  }

  const lookup = new SmartySDK.usZipcode.Lookup(undefined, undefined, zip);
  try {
    const response = await client.send(lookup);
    const result = response?.lookups?.[0]?.result?.[0] || response?.result?.[0];
    const states = [...new Set([
      ...(result?.zipcodes || []).map(item => item.stateAbbreviation),
      ...(result?.cities || []).map(item => item.stateAbbreviation),
    ].filter(Boolean))];

    if (states.length !== 1) {
      throw new Error(states.length > 1
        ? 'This ZIP spans multiple states. Select the patient state to continue.'
        : 'We could not identify a state for this ZIP code. Select the patient state to continue.');
    }
    return {
      state: states[0],
      city: result?.zipcodes?.[0]?.defaultCity || result?.cities?.[0]?.city || '',
    };
  } catch (error) {
    const rateLimitMsg = parseRateLimitError(error);
    if (rateLimitMsg) {
      const rateLimitErr = new Error(rateLimitMsg);
      rateLimitErr.isRateLimit = true;
      rateLimitErr.status = 429;
      throw rateLimitErr;
    }
    throw error;
  }
}
